module.exports = __webpack_public_path__ + "cdfe19264d56399fc94af0cde71e70b0.MP3";